import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品服务',
    links: [
      { label: '智能解决方案', path: '/category/smart-solutions' },
      { label: '数据分析平台', path: '/category/data-analytics' },
      { label: '云服务架构', path: '/category/cloud-services' },
      { label: '安全防护体系', path: '/category/security' },
      { label: '物联网平台', path: '/category/iot-platform' },
      { label: '企业协同工具', path: '/category/collaboration' },
    ],
  },
  resources: {
    title: '资源中心',
    links: [
      { label: '使用指南', path: '/article/aiye-data-driven-decision' },
      { label: '技术博客', path: '/article/aiye-security-best-practices' },
      { label: '产品动态', path: '/article/aiye-2025-product-vision' },
      { label: '常见问题', path: '/about' },
      { label: 'API 文档', path: '/about' },
      { label: '开发者社区', path: '/about' },
    ],
  },
  company: {
    title: '关于 aiye',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '加入我们', path: '/about' },
      { label: '合作伙伴', path: '/about' },
      { label: '隐私政策', path: '/about' },
      { label: '服务条款', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
            <div className="sm:col-span-2 lg:col-span-1">
              <Link to="/" className="inline-block">
                <span className="text-2xl font-heading font-bold tracking-tight text-white">
                  aiye
                </span>
              </Link>
              <p className="mt-4 text-sm leading-relaxed text-foreground-300 max-w-xs">
                aiye 致力于以技术创新驱动品质生活，为全球用户提供值得信赖的智能解决方案，成为行业标杆品牌。
              </p>
              <div className="flex items-center gap-3 mt-5">
                {[
                  { icon: 'ri-wechat-line', label: '微信' },
                  { icon: 'ri-weibo-line', label: '微博' },
                  { icon: 'ri-linkedin-box-line', label: '领英' },
                  { icon: 'ri-github-line', label: 'GitHub' },
                ].map((social) => (
                  <a
                    key={social.label}
                    href="#"
                    rel="nofollow"
                    className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer"
                    aria-label={social.label}
                  >
                    <i className={`${social.icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            {[footerLinks.product, footerLinks.resources, footerLinks.company].map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-white mb-4">
                  {section.title}
                </h4>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-300 hover:text-white transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} aiye. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-white transition-colors">
              隐私政策
            </a>
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-white transition-colors">
              服务条款
            </a>
            <a href="#" rel="nofollow" className="text-xs text-foreground-400 hover:text-white transition-colors">
              Cookie 设置
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}